import api from './api';

export const listMedia = () => api.get('/admin/media').then(r => r.data.media);

export const createMedia = ({ url, filename, label }) =>
  api.post('/admin/media', { url, filename, label }).then(r => r.data.media);

export const deleteMedia = (id) => api.delete(`/admin/media/${id}`);
